<template>
    <div
        class="loja-perfeita-list-skeleton"
        role="status"
        aria-live="polite"
    >
        <span class="sr-only">{{ screenReaderText }}</span>
        <b-skeleton-table
            :rows="rows"
            :columns="columns"
            :table-props="{ striped: true, hover: true }"
        />
    </div>
</template>

<script>
import Shared from '@src/mixins/shared.vue'

const i18nKey = 'LOJA_PERFEITA'

export default {
    name: 'LojaPerfeitaListSkeleton',
    mixins: [Shared],
    props: {
        rows: {
            type: Number,
            default: 5,
        },
        columns: {
            type: Number,
            default: 4,
        },
    },
    computed: {
        screenReaderText() {
            return this.getI18n(i18nKey, 'MESSAGES.loading_list') || 'Loading…'
        },
    },
}
</script>
